import moment from "moment";

export default function FormatDate(date, format) {
  if (moment().utcOffset() >= 0) {
    return moment(date).format(format);
  } else {
    return moment.utc(date).format(format);
  }
}
